/** Codes d'erreur OAuth 2.0 / OIDC renvoyés par /authorize et /token. */
export const OAUTH_ERRORS = {
    INVALID_REQUEST: 'invalid_request',
    INVALID_CLIENT: 'invalid_client',
    INVALID_GRANT: 'invalid_grant',
    UNAUTHORIZED_CLIENT: 'unauthorized_client',
    UNSUPPORTED_GRANT_TYPE: 'unsupported_grant_type',
    INVALID_SCOPE: 'invalid_scope',
    ACCESS_DENIED: 'access_denied',
    LOGIN_REQUIRED: 'login_required',
    CONSENT_REQUIRED: 'consent_required',
    /** RFC 8707 : ressource demandée inconnue ou non autorisée pour ce client. */
    INVALID_TARGET: 'invalid_target',
    SERVER_ERROR: 'server_error',
};
/** Codes métier du portail, destinés à un message utilisateur en français. */
export const AUTH_ERRORS = {
    INVALID_CREDENTIALS: 'invalid_credentials',
    EMAIL_ALREADY_USED: 'email_already_used',
    EMAIL_NOT_VERIFIED: 'email_not_verified',
    ACCOUNT_LOCKED: 'account_locked',
    ACCOUNT_SUSPENDED: 'account_suspended',
    MFA_REQUIRED: 'mfa_required',
    MFA_INVALID: 'mfa_invalid',
    TOKEN_EXPIRED: 'token_expired',
    TOKEN_INVALID: 'token_invalid',
    RATE_LIMITED: 'rate_limited',
};
export const AUTH_ERROR_MESSAGES = {
    invalid_credentials: 'Identifiants incorrects.',
    email_already_used: 'Un compte existe déjà avec cette adresse e-mail.',
    email_not_verified: 'Confirmez votre adresse e-mail pour ouvrir votre compte.',
    account_locked: 'Compte temporairement bloqué après trop de tentatives.',
    account_suspended: 'Compte suspendu, contactez le support.',
    mfa_required: 'Validation en deux étapes requise.',
    mfa_invalid: 'Code de validation invalide.',
    token_expired: 'Ce lien a expiré.',
    token_invalid: 'Ce lien est invalide.',
    rate_limited: 'Trop de tentatives, réessayez dans quelques minutes.',
};
//# sourceMappingURL=errors.js.map